import { Icon } from "@trustpilot/constellation-components";
import { externalLink_16 as externalLink } from "@trustpilot/icons";
import { Text, useTranslations } from "ilenia";
import React from "react";

import { StyledLink, StyledLinkButton, StyledList, StyledListItem } from "../styled";
import { StyledItemText, StyledTopBlock } from "./styled";
import * as Types from "./types";

/**
 * Maps from B2B locale to language query parameter expected on help site.
 */
const LOCALE_MAP: Record<string, string> = {
  "da-DK": "da",
  "de-DE": "de",
  "en-GB": "en_US",
  "en-US": "en_US",
  "es-ES": "es",
  "fr-FR": "fr",
  "it-IT": "it",
  "nl-NL": "nl_NL",
  "sv-SE": "sv",
};

const TechSupport: React.FC<Types.TechSupport> = ({ showLiveChatFeature, onLinkClicked, startChat }) => {
  const [translations, locale] = useTranslations();
  const languageParam = LOCALE_MAP[locale] ?? "en_US";

  const requestCallbackUrl = `https://trustpilot.my.site.com/webtocase/s/web-to-case?formname=requestCallback&language=${languageParam}`;

  return (
    <StyledTopBlock>
      <StyledList borderBottom aria-label={translations["BusinessUserSettings.help.resources"]}>
        {showLiveChatFeature && (
          <>
            <StyledListItem>
              <StyledLinkButton textAlignLeft onClick={startChat}>
                <StyledItemText>
                  <Text id="BusinessUserSettings.help.chatnow" />
                </StyledItemText>
              </StyledLinkButton>
            </StyledListItem>
            <StyledListItem>
              <StyledLink
                className="request-callback"
                href={requestCallbackUrl}
                target="_blank"
                onClick={onLinkClicked}
              >
                <StyledItemText>
                  <Text id="BusinessUserSettings.help.requestcall" />
                </StyledItemText>
                <Icon content={externalLink} />
              </StyledLink>
            </StyledListItem>
          </>
        )}

        <StyledListItem>
          <StyledLink
            href={`https://help.trustpilot.com/s/for-businesses?language=${languageParam}`}
            target="_blank"
            onClick={onLinkClicked}
          >
            <StyledItemText>
              <Text id="BusinessUserSettings.help.supportcenter" />
            </StyledItemText>
            <Icon content={externalLink} />
          </StyledLink>
        </StyledListItem>
        <StyledListItem>
          <StyledLink
            href={`https://help.trustpilot.com/s/getting-started?language=${languageParam}`}
            target="_blank"
            onClick={onLinkClicked}
          >
            <StyledItemText>
              <Text id="BusinessUserSettings.help.videoguides" />
            </StyledItemText>
            <Icon content={externalLink} />
          </StyledLink>
        </StyledListItem>
      </StyledList>
    </StyledTopBlock>
  );
};
export default TechSupport;
